module.exports = __webpack_public_path__ + "img/uid-token-bg.a69f1f88.png";